import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../home/components/TrustBar';
import WhyChooseUs from '../home/components/WhyChooseUs';
import Testimonials from '../home/components/Testimonials';
import ServiceAreas from '../home/components/ServiceAreas';
import ProcessTimeline from '../home/components/ProcessTimeline';
import MidCTA from '../home/components/MidCTA';
import Gallery from '../home/components/Gallery';
import LeadForm from '../home/components/LeadForm';
import MobileCallButton from '../home/components/MobileCallButton';
import AboutHero from './components/AboutHero';
import AboutCapabilities from './components/AboutCapabilities';
import AboutFAQ from './components/AboutFAQ';

export default function AboutPage() {
  return (
    <main>
      <Navbar />
      <AboutHero />
      <TrustBar />
      <AboutCapabilities />
      <WhyChooseUs />
      <Testimonials />
      <MidCTA />
      <ServiceAreas />
      <ProcessTimeline />
      <AboutFAQ />
      <Gallery />
      <LeadForm />
      <Footer />
      <MobileCallButton />
    </main>
  );
}
